<template>
  <content-editor
    permission="news"
    :publication="true"
    :fields="fields"
    @update="updateState"
    :updatePossible="true"
    endpoint="news"
    previewModule="actueel"
    module="news">
  </content-editor>
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  components: {
    ContentEditor,
  },
  data() {
    return {
      module: 'news',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'title',
          required: true,
        },
        {
          name: 'lightbox',
          required: false,
        },
        {
          name: 'read-confirmation',
          required: false,
        },
        {
          name: 'internal',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'recap',
          required: false,
        },
        {
          name: 'categories',
          required: true,
        },
        {
          name: 'tags',
          required: false,
        },
        {
          name: 'branches',
          required: false,
        },
        {
          name: 'targets',
          required: true,
        },
        {
          name: 'image',
          required: true,
        },
        {
          name: 'seo_keywords',
          required: false,
        },
      ],
    };
  },

};
</script>
